import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Dollar from '../../assets/Dollar.png';
import Envelope from '../../assets/envelope.png';
import Facebook from '../../assets/Facebook.svg';
import Handshake from '../../assets/Handshake.png';
import MessageDetail from '../../assets/message-detail.png';
import Smiley from '../../assets/Smiley.png';
import SupportHeader from '../../assets/support-header.png';
import { Layout } from '../../components/page-layout';
import ChoosingProduct from '../plan/components/choosingProduct';
import Questions from './components/questions';

const GlobalStyle = createGlobalStyle`
  body {
    background: #fff;
    color: #222;
    font-size: 18px;
    letter-spacing: 0;
  }
`;

const Main = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 0;
`;

const HeaderImg = styled.img`
  width: 100%;
  object-fit: cover;
  max-height: 340px;
  @media (max-width: 900px) {
    max-height: 200px;
  }
`;

const Section = styled.section`
  width: 100%;
  margin: 0 auto;
`;

const ContactSection = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const ContactTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 1.5rem;
  color: #480D05;
`;

const ContactSubtitle = styled.p`
  font-size: 1.15rem;
  text-align: center;
  margin-bottom: 2.5rem;
  color: #221511;
`;

const ContactCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media (min-width: 900px) {
    flex-direction: row;
    justify-content: center;
  }
`;

const Card = styled.div<{ bg: string }>`
  background: ${({ bg }) => bg};
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  padding: 2rem 1.5rem;
  width: 100%;
  max-width: 370px;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0rem 2rem;
`;

const CardIcon = styled.img`
  width: 48px;
  height: 48px;
  margin-bottom: 1rem;
`;

const CardTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: #480D05;
`;

const CardDesc = styled.p`
  font-size: 0.75rem;
  text-align: center;
  color: #221511;
  margin-bottom: 0.5rem;
`;

const CardAction = styled.p`
  margin: 2rem 0;
  width: 100%;
`;

const CardButton = styled.a<{ disabled?: boolean; border?: string; bg?: string }>`
  display: inline-block;
  width: 100%;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 700;
  padding: 1rem 0;
  border-radius: 12px;
  border: 1px solid ${({ border }) => border || '#A9DABB'};
  background: transparent;
  color: #221511;
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  text-decoration: none;
  transition: border 0.2s, color 0.2s;
  &:hover {
    background: transparent;
    color: #221511;
  }
`;

const WarrantyBar = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  padding: 2rem 2rem;
  margin-top: 2rem;
  background: #fff;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 0.5rem;
  }
`;

const WarrantyItem = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1.1rem;
  color: #444;
`;

export default () => {
  return (
    <Layout showCommonFooter>
      <GlobalStyle />
      <Main>
        <div style={{ width: '100vw', height: '360px', position: 'relative', left: '50%', right: '50%', marginLeft: '-50vw', marginRight: '-50vw' }}>
          <HeaderImg src={SupportHeader} alt="Support Header" style={{ width: '100vw', maxWidth: '100vw', display: 'block' }} />
        </div>
        <Questions />
        <ContactSection>
          <ContactTitle>Contact us</ContactTitle>
          <ContactSubtitle>
            Our team is here to help. Reach out anytime for support.
          </ContactSubtitle>
          <ContactCards>
            <Card bg="#C6F7D0">
              <CardIcon src={Envelope} alt="Email Icon" />
              <CardTitle>Email</CardTitle>
              <CardDesc>
                Drop us an email, and we'll get back to you within 48 hours with the answers you need!
              </CardDesc>
              <CardAction>
                <CardButton
                  href="mailto:support@sensforge.com"
                  border="#A9DABB"
                >
                  support@sensforge.com
                </CardButton>
              </CardAction>
            </Card>
            <Card bg="#E6D6FB">
              <CardIcon src={MessageDetail} alt="Live Chat Icon" />
              <CardTitle>Live chat</CardTitle>
              <CardDesc>
                Our AI bot is ready to assist you in real time—chat with us now and get the answers you need, fast!
              </CardDesc>
              <CardAction>
                <CardButton
                  as="span"
                  disabled
                  border="#999999"
                  bg="#eeeeee"
                >
                  Available Soon
                </CardButton>
              </CardAction>
            </Card>
            <Card bg="#C6E6FB">
              <CardIcon src={Facebook} alt="Facebook Icon" />
              <CardTitle>Facebook</CardTitle>
              <CardDesc>
                Join our Facebook group to connect with other users, share experiences, and find solutions together!
              </CardDesc>
              <CardAction>
                <CardButton
                  href="https://www.facebook.com/groups/sensforgecorecommunity"
                  border="#03387C"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sensforge Core Community
                </CardButton>
              </CardAction>
            </Card>
          </ContactCards>
        </ContactSection>
        <ChoosingProduct />
        <WarrantyBar>
          <WarrantyItem>
            <img src={Smiley} alt="2-Year Warranty" width={24} height={24} />
            <span>2-Year Warranty</span>
          </WarrantyItem>
          <WarrantyItem>
            <img src={Dollar} alt="30-Day Money-Back Guarantee" width={24} height={24} />
            <span>30-Day Money-Back Guarantee</span>
          </WarrantyItem>
          <WarrantyItem>
            <img src={Handshake} alt="Lifetime Customer Support" width={24} height={24} />
            <span>Lifetime Customer Support</span>
          </WarrantyItem>
        </WarrantyBar>
      </Main>
    </Layout>
  );
}
